var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDance9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 569,
    viewBox: "0 0 352 569",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2120_10884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.861 501.309C177.019 501.309 215.23 481.613 233.756 442.801L238.388 494.358H287.02V68H233.177V256.849C214.072 222.091 177.598 202.975 134.176 202.975C50.2282 202.975 -0.140625 266.697 -0.140625 353.59C-0.140625 439.904 49.6496 501.309 131.861 501.309ZM142.861 452.069C87.2814 452.069 54.8604 410.36 54.8604 351.852C54.8604 293.923 87.2814 252.214 142.861 252.214C198.44 252.214 232.598 293.923 232.598 351.852C232.598 410.94 198.44 452.069 142.861 452.069Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2120_10884"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 352,
    height: 569,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDance9);
export default __webpack_public_path__ + "static/media/dance9.746e920ae4440b9acc266eabfd9c343f.svg";
export { ForwardRef as ReactComponent };